import type { ReactNode } from 'react';
import { useThemeBootstrap } from '@/hooks/useThemeBootstrap';

type ThemeRootProps = {
  children: ReactNode;
};

/**
 * Mounts Redux-free theme bootstrap at the top of the tree so every route
 * — public or protected — applies the user's saved light/dark/system
 * preference. Pairs with the inline FOUC-prevention script in `index.html`:
 * the script covers first paint, this component covers React-lifetime
 * OS-preference changes and cross-tab sync.
 *
 * The full Redux-backed `useTheme` hook still runs inside `AppLayout` for
 * authenticated routes, where it reconciles with the server and exposes
 * `setTheme` for the Settings page.
 */
export function ThemeRoot({ children }: ThemeRootProps) {
  useThemeBootstrap();
  return <>{children}</>;
}
